<div class="d-flex flex-column">
  <div>
    <ul class="nav nav-tabs px-5">
      <li *ngFor="let tab of tabs" class="nav-item">
        <a (click)="tabSelected(tab)" (keydown.enter)="tabSelected(tab)" [class.active]="tab.active" class="nav-link px-4 d-flex"
           tabindex="0">
          <div [class.active]="tab.active" class="tab-font">{{tab.count}} {{tab.title}}</div>
        </a>
      </li>
    </ul>
  </div>
  <div class="col px-0">
    <ng-content></ng-content>
  </div>
</div>
